import React, { Component } from 'react';
import Teaser from '../../common/Teaser/Teaser';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import "./OurProducts.css";
import axios from 'axios';


export default class OurProducts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            responsive: {
                0: { items: 1 },
                450: { items: 2 },
                850: { items: 3 },
                1300: { items: 4 }
            },
            products: []
        }
        this.apiRootUrl = '/api/imo2020products/getproducts';
        this.apiInterface = {
            productName: 'Name',
            number: 'Number',
            description: 'Description',
            imageUrl: 'ImageUrl',
            externalUrl: 'ExternalUrl'
        };
        this.fetchProducts = this.fetchProducts.bind(this);
        this.mapResponse = this.mapResponse.bind(this);
    }

    componentDidMount() {
        this.fetchProducts();
    }

    fetchProducts() {
        axios.get(this.apiRootUrl)
            .catch(error => {
                console.log(error);
            })
            .then(response => {
                const mappedResponse = this.mapResponse(response);
                this.setState({ products: mappedResponse });
            })
    }

    mapResponse(response) {
        return response.data.map((item, index) => (<Teaser key={index}
            teaserText={item[this.apiInterface.productName]}
            teaserDetails={item[this.apiInterface.description]}
            imageUrl={item[this.apiInterface.imageUrl]}
            imageAlt={item[this.apiInterface.productName]}
            imageTitle={item[this.apiInterface.productName]}
            teaserUrl={item[this.apiInterface.externalUrl]}>
            {item[this.apiInterface.number] && <div className="publishInfo publishInfo--padded text--blue publishInfo__published">
                <span>Product number: <b>{item[this.apiInterface.number]}</b></span>
            </div>}
        </Teaser>))
    }

    render() {
        return <section className="teasers our-products">
            <div className="carousel-button teaser-list__carousel-button teaser-list__carousel-button--prev" onClick={() => this.Carousel.slidePrev()} />
            <div className="container">
                <h3 className="heading heading--tertiary heading--underlined text--blue">Our Products</h3>
                <div className="carousel-content">
                    <AliceCarousel
                        buttonsDisabled={true}
                        items={this.state.products}
                        responsive={this.state.responsive}
                        ref={(el) => (this.Carousel = el)}
                    />
                </div>
            </div>
            <div className="carousel-button teaser-list__carousel-button teaser-list__carousel-button--next" onClick={() => this.Carousel.slideNext()} />
        </section>
    }
}